export const searchListe = (item, params) => {
  let { search, filter } = params || {};
  if (filter && filter.kind && item.kind !== filter.kind) return false;
  if (filter && filter.make && item.make !== filter.make) return false;
  if (typeof search !== "string" || search.length < 3) return true;
  search = search.toLowerCase().trim();
  let regexBez = new RegExp(search);
  let regexKz = new RegExp("^" + Number(search));
  return !!(
    String(item.bezeichnung).toLowerCase().match(regexBez) ||
    String(item.isoCode).toLowerCase().match(regexBez) ||
    String(item.kennziffer).match(regexKz)
  );
};
